import { CwpEnvironment, VideoEnvironment } from '../_types/environment';

export const getCwpEnvironment = (): CwpEnvironment => {
	let env: CwpEnvironment;

	if (window.NTPT_GLBLEXTRA) {
		const segments = window.NTPT_GLBLEXTRA.split('&');
		segments.forEach((segment) => {
			const keyAndVal = segment.split('=');
			if (keyAndVal[0] === 'env') {
				env = (keyAndVal[1] as CwpEnvironment) || '';
			}
		});
	}

	return env;
};

/**
 * When not in Storybook, the environment will not be set and needs to be determined automatically.
 * This function helps decide which Cloudfront environment to load videos and captions/audio descriptions from,
 * based on the CWP environment that has been detected.
 * Note: The assumption is there will be no CORS issues, and therefore JSON is used rather than JSONP.
 */
export const getVideoEnvFromCwpEnv = (
	cwpEnv: CwpEnvironment
): VideoEnvironment => {
	switch (cwpEnv) {
		case 'local':
		case 'dev':
		case 'preprod':
		case 'tst':
		case 'tst2':
			return 'test';
		default:
			return 'prod';
	}
};
